import { Plus } from 'lucide-react'

import { Button } from '@/components/ui/button'

interface Props {
  label: string
  append: () => void
}

const AddObjectButton = ({ append, label }: Props) => {
  return (
    <Button variant="outline" onClick={() => append()}>
      <Plus className="mr-2 h-4 w-4" />
      {label}
    </Button>
  )
}

export default AddObjectButton
